import { lazy } from "react";

import type { VisualizerConfig } from "../types";

// Lazy so the r3f / three / drei / postprocessing stack loads only when this
// visualizer renders.
const SculpturePhoenix = lazy(() => import("./SculpturePhoenix"));

export const sculpturePhoenix: VisualizerConfig = {
  id: "sculpture-phoenix",
  name: "Sculpture",
  description:
    "The season sculpture assembling out of the void — real sculpted surface, molten growth frontier, team territories, honest damage. Three shapes to evaluate.",
  Component: SculpturePhoenix
};
